import { Injectable } from '@angular/core';

import { AppStateService, UtilitiesService } from '../../core/services';
import { Table } from '../../shared/components/table/view-models';
import { ContentRequestsRouteState } from '../_models';
import { UrlString } from '../_models/url-string.enum';

@Injectable({
	providedIn: 'root'
})
export class TableViewStateService {
	public config: any;
	public pageTitleSnippet: string;
	public route: ContentRequestsRouteState;
	public pageTitle: string;
	public pageNumber: number;
	public orderByCol: string;
	public orderDesc: boolean;
	public filterByStatus: string;
	public urlString: UrlString;
	public filterByRequestType: string;
	public searchTerm: string = '';
	public table: Table;
	public totalItems: number;
	public workflowFilter: string;

	constructor(private appStateService: AppStateService, private utilService: UtilitiesService) {}

	public setState(
		pageTitleSnippet: string,
		pageNumber: number,
		orderByCol: string,
		filterByStatus: string,
		filterByRequestType: string,
		urlString: UrlString,
		workflowFilter: string,
		route: ContentRequestsRouteState
	): void {
		this.pageTitleSnippet = pageTitleSnippet;
		this.pageNumber = pageNumber;
		this.orderByCol = orderByCol;
		this.filterByStatus = filterByStatus;
		this.filterByRequestType = filterByRequestType;
		this.urlString = urlString;
		this.workflowFilter = workflowFilter;
		this.route = route;
	}

	public checkRouteState(): ContentRequestsRouteState {
		const { activeUrl } = this.appStateService;
		switch (true) {
			case this.utilService.includes(activeUrl, ContentRequestsRouteState.SYSTEM_TOOLS):
				return ContentRequestsRouteState.SYSTEM_TOOLS;
			case this.utilService.includes(activeUrl, ContentRequestsRouteState.CLIENT_DETAILS):
				return ContentRequestsRouteState.CLIENT_DETAILS;
			default:
				return ContentRequestsRouteState.CONTENT_REQUESTS;
		}
	}
}
